import React from "react"
import {useSearchParams} from "react-router-dom";

type JSONDebugProps = {
    data: unknown
    label?: string
}

export function JSONDebug({data, label}: JSONDebugProps) {

    const [searchParams] = useSearchParams()

    if(!searchParams.has("debug")){
        return null
    }

    return (
        <div className="flex flex-col gap-4">
            {label && (<p className="text-red">{label}</p>)}
            <pre className="border-1 border-red bg-light-red text-red  rounded-md p-2">{JSON.stringify(data, null, 2)}</pre>
        </div>
    )

}